<script setup lang="ts">
import { inject, computed } from 'vue';
import type { Component } from 'vue';
import type { TClassBinding } from '~/interfaces/components/general';

interface ITabProps {
  title: string;
  id: string;
  icon?: Component;
  classBinding?: TClassBinding;
}

const props = withDefaults(defineProps<ITabProps>(), {
  icon: null,
  classBinding: null,
});

const activeTabId = inject<Ref<string>>('activeTabId');

const isActive = computed(() => activeTabId.value === props.id);
</script>

<template>
  <div
    v-show="isActive"
    v-bind="{ ...(!!classBinding && { class: classBinding }) }"
  >
    <slot />
  </div>
</template>
